// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"ab6233c1ca965f5f8c74","293":"d13c57d42c7ad2e43d45","518":"7a7dd353424d56cfaacd","779":"38e4211be50b45a52ac5"}[chunkId] + ".js";
};